import { render, staticRenderFns } from "./concatsControl.vue?vue&type=template&id=643a1301&scoped=true"
import script from "./concatsControl.vue?vue&type=script&lang=js"
export * from "./concatsControl.vue?vue&type=script&lang=js"
import style0 from "./concatsControl.vue?vue&type=style&index=0&id=643a1301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a1301",
  null
  
)

export default component.exports